export enum LeaguesNewQueryKeys {
  LeaguesNew = "leaguesNew",
  LeaguesSuspensions = "leaguesSuspensions",
  LeagueWithTranslations = "leaguesNew.withTranslations",
  LeagueMappings = "leaguesNew.mappings",
}
